module.exports = __webpack_public_path__ + "img/jiangbei.97ddcbae.png";